import { css } from "dx-styles"

import { tokens } from "./tokens"

/**
 * The base typography, as a plain style object so other files can spread it.
 *
 * The object form is what a recipe needs: a `recipe()`/`slotRecipe()` config
 * rejects an imported class with "supports only previously declared css()
 * results". A plain `css()` accepts one, which is what `bodyText` below is for.
 */
// No `as const`, and no type annotations anywhere in this file: wyw hands `.ts`
// files back with TypeScript-only syntax intact, which the browser then rejects
// in dev (`SyntaxError: Unexpected identifier 'as'`). `.tsx` files are safe —
// plugin-react's babel strips those.
export const bodyTextStyle = {
  fontFamily: tokens.font.body,
  fontSize: tokens.fontSize.body,
  lineHeight: tokens.lineHeight.body,
  fontWeight: tokens.fontWeight.regular,
  color: tokens.color.text,
}

/**
 * The same declarations as a class, for the app shell — everything inside
 * inherits body typography, and `<Text>` with no props matches it exactly
 * because `textRecipe`'s base is built from the same object.
 */
export const bodyText = css(bodyTextStyle)
